import styled from 'styled-components';
import {
  Title,
  Heading,
} from '@glowforge/gf-styled/components/typography/Typography';
import { GridContainer } from '@glowforge/gf-styled/components/grid-container';

export const StyledTitle = styled(Title)`
  grid-column: main-start / main-end;
  margin-bottom: 40px;

  @media ${(props) => props.theme.queries.desktopAndUp} {
    margin-bottom: 50px;
  }
`;

export const Wrapper = styled(GridContainer)`
  width: 100%;
  padding: 60px 0;

  & ${Heading} {
    color: ${(props) =>
      props.useMagicTitle
        ? props.theme.colors.magic.base
        : props.theme.colors.white};
  }

  @media ${(props) => props.theme.queries.desktopAndUp} {
    padding: 90px 0;
  }
`;

export const CarouselWrapper = styled('div')`
  grid-column: main-start / main-end;
`;

export const PaginationWrapper = styled('div')`
  grid-column: main-start / main-end;
  display: flex;
  justify-content: center;
  padding-top: 24px;
`;
